import { NAV_PATH } from '../../lib/nav';
import type { PageRoute } from '../../page-route';
import { AssistantPage } from './page';

/** «Помощник» (006, T077): разговоры с ИИ-агентом — в оболочке приложения, право `agent.thread`. */
export const route: PageRoute = { path: NAV_PATH.assistant, access: 'authed', Component: AssistantPage };
